<template>
    <footer class="bg-white">
    <div class="container p-6 mx-auto">
        <a href="/">
            <img class="w-auto mx-auto h-24" src="/img/Logo_outline.png" alt="">
            <h4 class="font-bold text-center text-primary-500">noc noc app</h4>
        </a>

        <hr class="h-px my-6 bg-gray-200 border-none">

        <div>
            <p class="text-center text-gray-500">
                Sitio desarrollado por Martin Gonzalo Velazquez. Copyright © 2024 noc noc. All rights reserved.
            </p>
            <p class="text-center text-gray-500">
                <a class= "hipervinculoMail" href="mailto:mgvelazquez32@gmail.com">Enviar correo electronico</a>
            </p>
        </div>
    </div>
</footer>
</template>
<script>
</script>